export default class TelcoHeaderEnrichment {

  static process(callback) {
    $.ajax({
      type: 'GET',
      url: window.subdomainTelkomsel + '/telcos/he'
    }).done(function(resp) {
      TelcoHeaderEnrichment.onHeSuccess(resp, callback);
    }).fail(function() {
      callback();
    });
  }

  static onHeSuccess(resp, callback){
    var data = resp.result;
    if (data) {
      TelcoHeaderEnrichment.setCookieWatch(data, callback);
    } else {
      callback();
    }
  }

  static setCookieWatch(data, callback) {
    $.ajax({
      type: 'POST',
      url: '/telcos/she',
      data: { 'data' : data }
    }).always(function() {
      callback();
    });
  }
}
